import { useSettings } from "./providers";
import { useI18n } from "../i18n";
import { API } from "./api";

export const publicFileUrl = (p) => `${API}/public/files/${p}`;
const BUILT_IN = ["silver", "gold", "gold_plus"];

export const usePlans = () => {
  const { settings } = useSettings();
  const { t } = useI18n();
  const plans = settings?.plans || [];
  const getPlan = (k) => plans.find((p) => p.key === k);
  const planName = (k) => getPlan(k)?.name || (BUILT_IN.includes(k) ? t(`pk_${k}`) : k);
  return { plans, activePlans: plans.filter((p) => p.active), getPlan, planName };
};
